import * as React from "react";
import {Tabs} from "shared/controls/Tabs/Tabs";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import 'shared/styles/bootstrapminimal.css';
import {General} from "./Tabs/General";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
import {ToastService} from "shared/core/services/ToastService";
import {faBug} from "@fortawesome/free-solid-svg-icons/faBug";
import {SettingsOptions} from "./SettingsOptions";


export class SettingsApp extends React.Component<SettingsAppProps, SettingsAppState> {
    static defaultProps: Partial<SettingsAppProps> = {};

    constructor(props: SettingsAppProps) {
        super(props);
        this.state = {
            IsBusy:false,
            TabToOpen:'Settings'
        };
    }

    public render() {
        return (
            <div className={'rednao'} style={{margin:10}}>
                <div style={{margin:0,marginBottom:10,display:'none'}}>
                    <h1>Settings</h1>
                    <SpinnerButton IsBusy={this.state.IsBusy} OnClick={()=>this.Save()}>Save</SpinnerButton>
                </div>
                <Tabs TabToOpen={this.state.TabToOpen} TabToOpenChanged={x=>this.setState({TabToOpen:x})}>
                    <Tabs.Item Title={'General'} Icon={<FontAwesomeIcon icon={faCog}/>} Id={'Settings'} style={{backgroundColor:'white'}}>
                        <General Settings={this.props.SettingOptions} />
                    </Tabs.Item>
                </Tabs>
            </div>
        )
    }

    private async Save() {
        this.setState({IsBusy:true});
        let result=await WpAjaxPost.Post('save_settings',this.props.SettingOptions.ToObject());
        if(result!=null)
            ToastService.SendSuccess('Settings saved successfully');
        this.setState({IsBusy:false});
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface SettingsAppProps {
    SettingOptions:SettingsOptions;


}

interface SettingsAppState {
    IsBusy:boolean;
    TabToOpen:string;
}

//#endregion "My Region"